import { WorkGroup } from '@/types/workGroup';
import { OptionType } from '@/ui/components/Form/Select/types';

const setWorkGroupSelectValue = (workGroup: WorkGroup): OptionType<string> => {
  return {
    label: workGroup.name,
    value: workGroup.id
  };
};

export default setWorkGroupSelectValue;
